/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { NBCall } from '../../../bridges/nebula/index.js';
import '../../../index.es-142c5680.js';
import '../../../bridge-adpter-api-0316c034.js';
import '../../../tslib.es6-e01eabb2.js';

function saveImage(params) {
    var formatInput = function (options) {
        var _a;
        return ({
            src: options.url,
            showActionSheet: (_a = options.showActionSheet) !== null && _a !== void 0 ? _a : false,
            cusHandleResult: true,
        });
    };
    NBCall('saveImage', params, { formatInput: formatInput });
}

export { saveImage as default };
